<template>
  <footer id="footer">
    <div class="container">

    </div>
  </footer>
</template>

<script>
import { defineComponent, h, computed } from 'vue'
import { Line } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale,
  // Plugin
} from 'chart.js'

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    PointElement,
    CategoryScale
)

export default defineComponent({
  name: 'LineChart',
  components: {

  },
  props: {
    chartId: {
      type: String,
      default: 'line-chart'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 280
    },
    groupedOrders:Array,
    groupedBatches: Array,
    cssClasses: {
      default: '',
      type: String
    },
  },

  setup(props) {
    const chartData = computed(() => ({
      labels: ['Sat', 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
      datasets: [
        {
          label: 'Orders',
          borderColor: '#7549FF',
          pointBackgroundColor: 'white',
          borderWidth: 2,
          pointBorderColor: '#FFC350',
          backgroundColor: '#FFC350',
          data: Array.isArray(props.groupedOrders) ? props.groupedOrders : [0, 0, 0, 0, 0, 0, 0],
          fill: false,
        },
        {
          label: 'BPNs',
          borderColor: '#4CAF50',
          pointBackgroundColor: 'white',
          borderWidth: 2,
          pointBorderColor: '#FFC350',
          backgroundColor: '#FFC350',
          data: Array.isArray(props.groupedBatches) ? props.groupedBatches : [0, 0, 0, 0, 0, 0, 0],
          fill: false,
        },
      ]
    }))

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      elements: {
        line: {
          tension: 0
        }
      },
      plugins: {
        legend: {
          display: false
        }
      },
      scales: {
        x: {
          ticks: {
            color: '#92959E'
          },
          grid: {
            display: false,
          },
        },
        y: {
          beginAtZero: true, 
          min: 0,
          ticks: {
            color: '#92959E'
          },
          grid: {
            display: false
          }
        },
      },
    }


    return () =>
        h(Line, {
          chartData: chartData.value,
          chartOptions,
          chartId: props.chartId,
          width: props.width,
          height: props.height,
          cssClasses: props.cssClasses,
          styles: props.styles,
          plugins: props.plugins
        })
  }

})

</script>
